import PensionsInfoUdbetalingerView from './PensionsInfoUdbetalingerView.js';

export default PensionsInfoUdbetalingerView;
